<template>
  <div :class="['flexRow', 'blockRow', color]">
    <!-- <transition-group name="blocks" tag="div"> -->
    <block
      v-for="(block, key) in blocks"
      :block="block"
      :blockId="key"
      :categoryId="categoryId"
      :customDate="customDate"
      :color="color"
    />
    <new-block
      :class="['quota', isQuotaMet ? 'quotaMet' : '']"
      v-for="n in numRemaining"
      :categoryId="categoryId"
      :customDate="customDate"
    />
    <!-- </transition-group> -->
  </div>
</template>

<script>
import Block from "./Block.vue";
import NewBlock from "./NewBlock.vue";

export default {
  name: "block-row",
  components: {
    block: Block,
    "new-block": NewBlock,
  },
  props: {
    blocks: {
      type: [Array, Object],
      default: function() {
        return [];
      },
    },
    color: {
      type: String,
      default: "blue",
    },
    categoryId: String,
    quota: Number,
    isContinuous: {
      type: Boolean,
      default: false,
    },
    customDate: {
      type: String,
      default: "",
    },
  },
  computed: {
    numRemaining() {
      let completed = this.blocks ? Object.keys(this.blocks).length : 0;
      return Math.max(this.quota - completed, this.isContinuous ? 1 : 0);
    },
    isQuotaMet() {
      let completed = this.blocks ? Object.keys(this.blocks).length : 0;
      return completed >= this.quota;
    },
  },
};
</script>

<style>
/*.block {
    transition: background-color 1.5s;
}*/

/* FIXME - Change this to a single flexRow class */
.blockRow {
  padding: 0.75rem;
}

/* BLOCK COLORS */
.blockRow.red > .block {
  background-color: #ff3a24;
}

.blockRow.orange > .block {
  background-color: #e67e22;
}

.blockRow.yellow > .block {
  background-color: #f1c40f;
}

.blockRow.green > .block {
  background-color: #2ecc71;
}

.blockRow.turquoise > .block {
  background-color: #1abc9c;
}

.blockRow.blue > .block {
  background-color: #3498db;
}

.blockRow.purple > .block {
  background-color: #9b59b6;
}

.blockRow.pink > .block {
  background-color: #ff2470;
}

.blockRow.lightGray > .block {
  background-color: #ecf0f1;
}

.blockRow.darkGray > .block {
  background-color: #95a5a6;
}

.blockRow.black > .block {
  background-color: #34495e;
}

.blockRow.white > .block {
  background-color: #fff;
}

.blockRow > .block.new {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// BlockRow.vue?82415b9c